import React, { useState } from "react";

const emirates = [
  {
    title: "Dubai",
    text: "Our Dubai team works with businesses looking for a reliable mobile app development company to build custom iOS, Android, and cross-platform applications.",
  },
  {
    title: "Abu Dhabi",
    text: "We help businesses in Abu Dhabi develop secure and scalable mobile applications designed around their customers and business goals.",
  },
  {
    title: "Sharjah",
    text: "We support startups and growing businesses in Sharjah with custom mobile app solutions that help improve customer experience and business operations.",
  },
  {
    title: "Ajman",
    text: "We work with Ajman businesses to create mobile applications that support growth, improve efficiency, and connect with customers.",
  },
  {
    title: "Ras Al Khaimah",
    text: "We build mobile applications for businesses in Ras Al Khaimah across industries such as hospitality, logistics, retail, and services.",
  },
  {
    title: "Fujairah",
    text: "We help Fujairah businesses develop digital solutions that support their operations and customer needs.",
  },
  {
    title: "Umm Al Quwain",
    text: "We provide the same professional mobile app development services for businesses in Umm Al Quwain with complete design, development, and support.",
  },
  {
    title: "Al Ain",
    text: "We work with Al Ain businesses through flexible remote and onsite collaboration to deliver custom mobile applications.",
  },
];

export default function Section11() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (index) => {
    setOpenIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <div className="w-full Section11 py-[35px]">
      <div className="container-1280 section11-container w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%]">
        <h2 className="text-[22px] md:text-[30px] font-bold leading-[28px] md:leading-[38px] text-center my-[0.67em] text-[#151515]">
          Mobile App Developers Serving Businesses Across UAE
        </h2>

        <div className="w-full md:w-[85%] mx-auto text-center leading-[22px] text-[#535353] text-sm md:text-base font-open mb-8 space-y-3">
          <p>
            Mean3 works with businesses across all Emirates, providing the
            same professional mobile app development services in Dubai, Abu
            Dhabi, Sharjah, Ajman, Ras Al Khaimah, Fujairah, Umm Al Quwain,
            and Al Ain.
          </p>
          <p>
            Whether you are a startup, SME, or established company, our team
            helps UAE businesses build custom mobile applications with the
            same development process, quality standards, and support
            experience regardless of location.
          </p>
        </div>

        <div className="w-full md:w-[85%] mx-auto">
          {emirates.map((item, index) => (
            <div
              key={item.title}
              className="border border-[#EDEDED] rounded-[6px] mb-3 overflow-hidden"
            >
              <div
                onClick={() => toggle(index)}
                className="cursor-pointer flex justify-between items-center px-5 py-4 bg-[#F5F5F5]"
              >
                <h3 className="text-sm md:text-base font-bold text-[#151515] font-open">
                  {item.title}
                </h3>
                <b className="text-[22px] text-[#cd2122] font-[300]">
                  {openIndex === index ? "-" : "+"}
                </b>
              </div>
              {openIndex === index && (
                <p className="text-xs md:text-sm text-[#535353] leading-[20px] font-open px-5 py-4">
                  {item.text}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
